import { StoreEntity } from './store.type';

export enum ArticleStatus {
  ENABLE = 'enable',
  DISABLE = 'disable',
}

export enum ArticleType {
  FAQ = 'faq_training',
  NOTICE = 'notice_training',
  EVENT = 'event_training',
  BLOG = 'blog_training',
}

export interface ArticleUpfileEntity {
  id: number;
  articleId: number;
  upfileId: number;
  status: ArticleStatus;
  registerDatetime: string;
  disableDatetime: string;
}

export interface BoardEntity {
  id: number;
  type: ArticleType;
  name: string;
  registerDatetime: string;
}

export interface BaseArticleEntity {
  id: number;
  title: string;
  viewDatetime: string;
}

export interface ArticleEntity extends BaseArticleEntity {
  boardId: number;
  storeId: number;
  thumbUpfileId: number;
  mainBannerUpfileId: number;
  author: string;
  content: string;
  status: ArticleStatus;
  numRead: number;
  point: number;
  registerDatetime: string;
  modifyDatetime: string;
  readDatetime: string;
  isTop: boolean;
  classType: string;
  startDatetime: string;
  endDatetime: string;
  subTitle: string;
  keywords: string;
  iconBcolor: string;
  iconFcolor: string;
  iconText: string;
  board: BoardEntity;
  upfiles: ArticleUpfileEntity[];
  thumbUpfile: string;
  thumbPath: string;
  mainBannerUpfile: string;
  mainBannerPath: string;
  store?: StoreEntity;
  previous?: BaseArticleEntity;
  next?: BaseArticleEntity;
}

export interface GetArticleListParams {
  page?: number;
  limit?: number;
  type?: ArticleType;
}

export interface ArticleListResponse {
  totalCount: number;
  limit: number;
  articles: ArticleEntity[];
}

export interface ArticleListProps {
  items: ArticleEntity[];
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}
